import { Injectable } from "@angular/core";
import { Configuration } from "./configuration";


@Injectable({
  providedIn: "root",
})
export class ConfigurationService {
  private configuration: Configuration;

  get(): Configuration {
    return this.configuration;
  }

  async loadConfiguration(): Promise<void> {
    const response = await fetch("/api/configuration");
    const configuration = await response.json();
    this.configuration = configuration;
    // console.log(this.configuration.test)
  }
  getAPIBaseUrl(): string {
    return this.configuration.apiEndpoint;
  }
  getURL(): string {
    return this.configuration.url
  }
  getsubscriptionURL(): string {
    return this.configuration.subscriptionURL;
  }
  getapiEndpointforchecksubcription(): string {
    return this.configuration.apiEndpointforchecksubcription;
  }

  getCommonApi(): string {
    return this.configuration.commonApi;
  }


}
